import { ThemeDefinition } from 'vuetify';

export const technology: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#124D91',
    'on-subject-original': '#FFFFFF',
    subject: '#104684',
    'on-subject': '#FFFFFF',
    primary: '#0F3F76',
    'on-primary': '#FFFFFF',
    'primary-container': '#BBD7F7',
    'on-primary-container': '#071D36',
    secondary: '#495B6E',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#D1D8E0',
    'on-secondary-container': '#181E25',
    surface: '#F7FAFC',
    'on-surface': '#1D201D',
    'on-surface-medium': '#494C50',
    'on-surface-low': '#94999E',
    outline: '#7A7F85',
    'outline-variant': '#C9CCCF',
    'inverse-surface': '#243242',
    'inverse-on-surface': '#EEF2F6',
    'inverse-primary': '#A4C9F4',
    'surface-dim': '#C2D5EB',
    'surface-bright': '#FBFCFE',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F0F4FA',
    'surface-container': '#E8EFF7',
    'surface-container-high': '#D9E5F2',
    'surface-container-highest': '#D1DFF0',
  },
};

export const technologyDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#124D91',
    'on-subject-original': '#F6FAFE',
    subject: '#84B7F0',
    'on-subject': '#071D36',
    primary: '#B2D1F5',
    'on-primary': '#071D36',
    'primary-container': '#114888',
    'on-primary-container': '#E8F2FC',
    secondary: '#C8D0DA',
    'on-secondary': '#181E25',
    'secondary-container': '#3D4B5C',
    'on-secondary-container': '#F0F2F5',
    surface: '#101419',
    'on-surface': '#F2F2F3',
    'on-surface-medium': '#C9CCCF',
    'on-surface-low': '#797F86',
    outline: '#94999E',
    'outline-variant': '#61666B',
    'inverse-surface': '#DEE5ED',
    'inverse-on-surface': '#151E28',
    'inverse-primary': '#0B305B',
    'surface-dim': '#0E1215',
    'surface-bright': '#2F3A46',
    'surface-container-lowest': '#0C0F12',
    'surface-container-low': '#14191F',
    'surface-container': '#1B2128',
    'surface-container-high': '#232B34',
    'surface-container-highest': '#2D3743',
  },
};
